import React, { useMemo } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { Course } from "src/types/coaching/courses";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import styles from "./content.module.scss";
import { EditLessonContent } from "./lesson";
import { EditAssessmentContent } from "./assessment";
import EmptyMessage from "src/components/emptyMessage";

const emptyLessonsIcon = '/images/coaching/empty_lessons.svg';
const emptyAssessmentsIcon = '/images/coaching/empty_assessments.svg';

interface EditCourseContentProps {
  course: Course;
  contentIndex: number;
  onAddLessonClicked: () => void;
  onAddAssessmentClicked: () => void;
}

export const EditCourseContent: React.FC<EditCourseContentProps> = ({ course, contentIndex, onAddLessonClicked, onAddAssessmentClicked }) => {
  const courseContent = useMemo(() => {
    return _.get(course, `contents[${contentIndex}]`);
  }, [course, contentIndex]);

  const entityType = useMemo(() => {
    return _.get(courseContent, "entityType");
  }, [courseContent]);

  if (!courseContent) {
    return (
      <div className={styles.placeholderContent}>
        <div className={styles.wrapper}>
          <EmptyMessage
            className={styles.emptyMessage}
            width={300}
            image={emptyLessonsIcon}
            message="No lessons added to course yet!"
            action={{
              title: "Add lesson",
              icon: 'paperflite-add',
              variant: 'gradient',
              onClick: () => { onAddLessonClicked() }
            }}
          />

          <div className={styles.orContainer}>
            <div className={styles.verticalLine}></div>
            <div className={styles.or}>or</div>
            <div className={styles.verticalLine}></div>
          </div>

          <EmptyMessage
            className={styles.emptyMessage}
            width={300}
            image={emptyAssessmentsIcon}
            message="No assessments added to course yet!"
            action={{
              title: "Add assessment",
              icon: 'paperflite-add',
              variant: 'gradient',
              onClick: () => { onAddAssessmentClicked() }
            }}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={styles.content}>
      {courseContent && entityType === "lesson" && (
        <EditLessonContent course={course} lesson={courseContent} />
      )}

      {courseContent && entityType === "assessment" && (
        <EditAssessmentContent course={course} assessment={courseContent} />
      )}
    </div>
  );
}